import {Component, Input, OnInit } from '@angular/core';
import {CommonModule } from '@angular/common';
import { AuthenticateService } from '../../../auth/authentication.service';
import { Router } from '@angular/router';
import {User, UserType} from '../../../user/user.mode';
import { ErrorManager } from '../../../utils/errorManager';


@Component({
  selector: 'partial-sidenav-menu',
  styles: [],
  templateUrl: './sidenav-menu.component.html'
})

export class AppSidenavMenuComponent implements OnInit{

  constructor(
    private authenticate:AuthenticateService,
    private router: Router,
    private errorManager : ErrorManager
  ){

  }

  userInfo:User;
  isAdministrator:boolean = false;
  vendorMenuTitle:string = '상점 정산조회';

  ngOnInit() {
    this.authenticate.getUserInfo().subscribe(res => {
        let resultBody = JSON.parse(res['_body']);
        //console.log(resultBody)
        if(resultBody.status === 'success'){
          let userObj = resultBody.body['userInfo'];
          this.userInfo = new User(
            userObj['userNo'],
            userObj['userId'],
            userObj['vendorSeq'],
            userObj['vendorName'],
            userObj['userType'],
            userObj['latestAt'],
            userObj['useYn']
          );

          if(this.userInfo.userType === 'HQ'){
            let hqInfo = resultBody.body['hqInfo'];
            this.userInfo.hqCode = hqInfo['hqCode'];
            this.userInfo.hqName = hqInfo['vendorName'];
            this.userInfo.hqSeq = hqInfo['vendorSeq'];
          }

          if(this.userInfo.userType === 'LO'){
            let hqInfo = resultBody.body['vendorInfo']['hqInfo'];
            let vendorInfo = resultBody.body['vendorInfo'];
            this.userInfo.hqName = hqInfo['vendorName'];
            this.userInfo.hqSeq = hqInfo['vendorSeq'];
            this.userInfo.hqCode = vendorInfo['hqCode'];
            this.userInfo.shopCode = vendorInfo['shopCode'];
            this.userInfo.vendorCode = vendorInfo['vendorCode'];
          }
          this.setActivateLayout();
        }
      },
      error => {
        this.errorManager.catchedError(JSON.parse(error['_body']));
      })
  }

  setActivateLayout(){
    if(this.userInfo.useYn === 'N') this.router.navigateByUrl('/common/sign-in/expired');
    if(this.userInfo.userType.toString() === 'ADM'){
      this.isAdministrator = true;
      this.router.navigateByUrl('/app/calculate/admin');
    }
    if(this.userInfo.userType.toString() === 'HQ'){
      this.vendorMenuTitle = '본사 정산조회';
      this.router.navigateByUrl('/app/calculate/vendor');
    }
    if(this.userInfo.userType.toString() === 'LO'){
      this.router.navigateByUrl('/app/calculate/vendor');
    }
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts